import { observer } from 'mobx-react-lite'
import { EnumHelperText, TextFieldWithLabel, Typography } from 'shared/ui'
import { InputPhone, makeTextFieldAutoFocus } from 'shared/ui/TextField'
import { NextButton } from 'pages/settings/ui/NextButton/NextButton'
import { type EnterNumberStore } from 'pages/settings/ui/EnterNumberCommon/store/EnterNumberStore'
import styles from './styles.module.scss'

export const EnterNumberCommon = observer(
  ({ store, nextClickHandler }: { store: EnterNumberStore; nextClickHandler: () => void }) => {
    const {
      nextDisabled,
      phone,
      setPhone,
      phoneError,
      focusTrigger,
      phoneSuccess,
      nextLoading,
      phoneDisabled,
    } = store

    return (
      <>
        <Typography
          color='tertiary'
          variant='body-md-regular'
          ariaLabel='EnterNumberDescription'
          marginTop={'16px'}
          className={styles.description}
        >
          Please enter your landline number. We will check if it is eligible for text enabling and
          call the number to verify it.
        </Typography>

        <TextFieldWithLabel
          marginTop={'40px'}
          labelProps={{
            label: {
              text: 'Phone number',
            },
          }}
          helperTextProps={
            phoneSuccess
              ? {
                  variant: EnumHelperText.Success,
                  text: phoneSuccess,
                  icon: 'checkboxChecked',
                }
              : undefined
          }
          errorMessage={phoneError}
          textFieldProps={{
            onChange: setPhone,
            value: phone,
            disabled: phoneDisabled,
            Input: InputPhone,
            InputProps: {
              placeholder: '(123) 123-1234',
            },
            mainActions: [makeTextFieldAutoFocus({ withFocus: true, focusTrigger })],
          }}
        />

        <NextButton
          text='Next'
          disabled={nextDisabled}
          loading={nextLoading}
          onClick={nextClickHandler}
        />
      </>
    )
  }
)
